import { render } from "./SignUpForm.vue?vue&type=template&id=e2749bd6"
import script from "./SignUpForm.vue?vue&type=script&lang=js"
export * from "./SignUpForm.vue?vue&type=script&lang=js"

import "./SignUpForm.vue?vue&type=style&index=0&id=e2749bd6&lang=css"

import exportComponent from "C:\\Users\\The Knight\\Desktop\\Cashoo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__